import { node, string } from "prop-types";
import React from "react";
import { twMerge } from "tailwind-merge";

const Icon = ({ className, icon }) => {
  return (
    <span
      className={twMerge(
        "inline-flex justify-center items-center align-center grow-0 shrink-0",
        "[&>svg]:size-full",
        className
      )}
    >
      {icon}
    </span>
  );
};

Icon.propTypes = {
  className: string,
  icon: node,
};

export default Icon;
